import React, { BaseSyntheticEvent, useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import Sidebar from './components/Sidebar.tsx';
import FileUpload from './components/pages/FileUpload.tsx';
import Instructions from './components/pages/Instructions.tsx';
import PricingInstructions from './components/pages/PricingInstructions.tsx';
import AuditSeachResult from './components/pages/AuditSeachResult.tsx';
import { apiScope } from './util/authConfig.ts';
import HomePage from './components/pages/Home.tsx';
import './styles/App.scss';

export const PAGE_NAMES = {
  home: "HOME",
  FileUpload: "FILE_UPLOADS",
  FileUploadNS: "FILE_UPLOADS_NS",
  SearchProducts: "SEARCH_PRODUCTS",
  AuditSeachResult: "AUDIT_SEARCH_RESULT",
  Instructions: "INSTRUCTIONS",
  PricingInstructions: "PRICING_INSTRUCTIONS",
};

export const USER_TYPES = {
  admin: "Admin",
  buyer: "Buyer"
};


const ITEM_UPLOAD_NETSUITE_TRAY = process.env.REACT_APP_TRAY_IFRAME_URL_ITEM_FOR_NS ?? "";

const App = () => {
  const { instance, accounts, inProgress } = useMsal();
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(PAGE_NAMES.FileUpload);
  const [accessToken, setAccessToken] = useState<string>();
  const [userType, setUserType] = useState(USER_TYPES.admin);
  const [userName, setUserName] = useState<string>();
  const [userEmail, setUserEmail] = useState<string>();

  useEffect(() => {
    if (inProgress === InteractionStatus.None && accounts.length < 1) {
      instance.loginRedirect();
    } else if (inProgress === InteractionStatus.None && accounts.length >= 1) {
      const accessTokenRequest = {
        scopes: apiScope,
        account: accounts[0]
      };

      instance.acquireTokenSilent(accessTokenRequest)
        .then(res => {
          setAccessToken(res.accessToken);
        })
        .catch(err => console.warn('useEffect login error:', err));
    }
  }, [instance, accounts, inProgress]);

  useEffect(() => {
    const email = instance.getAllAccounts()[0]?.idTokenClaims?.emails;
    const name = instance.getAllAccounts()[0]?.idTokenClaims?.name;
    const isZachysEmail = email && email[0].includes('zachys.com');
    if (accessToken && isZachysEmail) {
      setUserType(USER_TYPES.admin);
      setUserName(name);
      setUserEmail(email[0]);
    }
  }, [accessToken]);

  // For Avatar:
  const getInitials = () => {
    const name = instance.getAllAccounts()[0]?.idTokenClaims?.name ?? '';
    const words = name.split(' ');
    let output: string = words[0][0];
    if (words[1]) {
      output = `${words[0][0]}${words[1][0]}`;
    }
    return output.toUpperCase();
  };

  return (
    <>
      {
        accessToken ? (
          <>

            <div className={`content-window ${currentPage === PAGE_NAMES.home || currentPage === PAGE_NAMES.FileUpload || currentPage === PAGE_NAMES.FileUploadNS || currentPage === PAGE_NAMES.AuditSeachResult ? '' : ''}`}>
              <div >{/*className="nav-bar"}
                {/*{currentPage === PAGE_NAMES.home && (
                  <h3>Home Page</h3>
                )}
                {currentPage === PAGE_NAMES.FileUpload && (
                  <h3>Upload Files Page</h3>
                )}*/}
                <div className="hero">
                  <div className="user-info-container"><br /> </div>
                  <div className="hero-content">
                    <img src="/zachys-logo-transp.png" alt="Zachys Logo" className="logo" /><br /><br /><br />
                    <h1>Automated Product Attribution</h1>
                  </div>
                  {accessToken && (
                    <div className="user-info-container" >
                      <div className="user-avatar">{getInitials()}</div>
                    </div>
                  )}
                </div>
              </div>
              <div>
                {<Sidebar
                  activePage={currentPage}
                  handlePageChange={setCurrentPage}
                  isDisabled={(accessToken) || !isLoading ? false : true}
                  userType={userType}
                />
                }
              </div>
              <div className={`content `}>
                {currentPage === PAGE_NAMES.FileUploadNS && (
                  <iframe
                    src={ITEM_UPLOAD_NETSUITE_TRAY}
                    width="100%"
                    height="500px"
                    frameBorder="0"
                    title="NetSuite File Upload"
                  />
                )}
                {currentPage === PAGE_NAMES.FileUpload && (

                  <FileUpload
                    accessToken={accessToken}
                    userName={userName ?? ""}
                    userEmail={userEmail ?? ""}
                  />
                )
                }
                {currentPage === PAGE_NAMES.Instructions && (

                  <Instructions
                  />
                )
                }
                {currentPage === PAGE_NAMES.PricingInstructions && (

                  <PricingInstructions
                  />
                )
                }
                {currentPage === PAGE_NAMES.AuditSeachResult && (
                  <AuditSeachResult
                    accessToken={accessToken}
                    userName={userName ?? ""}
                    userEmail={userEmail ?? ""}
                  />
                )}

              </div>

            </div>
          </>
        )
          : (
            <div>
              <h1>Logging in...</h1>
            </div>
          )}
    </>
  );
}

export default App;
